import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, I18nConfig, I18nModule, provideConfig, provideDefaultConfig, UrlModule } from '@spartacus/core';
import {
  ItemCounterModule,
  MediaModule,
  ProductListItemContext,
  ProductListItemContextSource,
  StarRatingModule
} from '@spartacus/storefront';
import { UigAddToCartModule } from '../uig-cart/uig-add-to-cart/uig-add-to-cart.module';
import { UigWishListComponent } from './components/uig-wish-list/uig-wish-list.component';
import { UigWishListItemComponent } from './components/uig-wish-list-item/uig-wish-list-item.component';
import { UigWishListService } from './uig-wish-list.service';
import { UigAddToWishlistComponent } from '../uig-product/uig-add-to-wishlist/uig-add-to-wishlist.component';
import {WishListService} from '@spartacus/cart/wish-list/core';
import { UigMarketplaceIconModule } from '../uig-product/uig-marketplace-icon/uig-marketplace-icon.module';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MediaModule,
    RouterModule,
    StarRatingModule,
    UrlModule,
    ItemCounterModule,
    UigAddToCartModule,
    UigMarketplaceIconModule
  ],
  declarations: [UigWishListItemComponent, UigWishListComponent],
  providers: [
    { provide: WishListService,
      useClass: UigWishListService
    },
    { provide: UigAddToWishlistComponent,
      useClass: UigAddToWishlistComponent
    },
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
    provideConfig({
      cmsComponents: {
        WishListComponent: {
          component: UigWishListComponent,
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
    provideConfig({
      i18n: {
        chunks: { uigWishList: ['uigWishList'] },
      },
    } as I18nConfig),
  ],
  exports: [UigWishListComponent, UigWishListItemComponent]
})
export class UigWishListModule { }
